import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  AssignedCreditCard,
  type AssignedCreditCardConstructor,
} from './AssignedCreditCard'

export const AssignedCreditCardConstructorFactory =
  Factory.Sync.makeFactory<AssignedCreditCardConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.finance.accountName()),
    number: Factory.each(() => `****${faker.finance.account(4)}`),
    type: Factory.each(() => faker.random.number({ min: 1, max: 5 })),
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
  })

export const AssignedCreditCardFactory = EntityFactory(
  AssignedCreditCard,
  AssignedCreditCardConstructorFactory
)
